import { useEffect } from 'react';
import { useEditor } from '../state/store';

/** How long a notice stays before it dismisses itself. */
const NOTICE_MS = 5000;

/**
 * Transient message on the board — a failed upload, a refused action.
 *
 * The region is always mounted and only its content changes, so screen
 * readers announce the message; a region inserted together with its text is
 * usually skipped.
 */
export function BoardNotice() {
  const notice = useEditor((s) => s.notice);

  useEffect(() => {
    if (!notice) return;
    const id = window.setTimeout(() => useEditor.getState().dismissNotice(notice.id), NOTICE_MS);
    return () => window.clearTimeout(id);
  }, [notice]);

  return (
    <div className="board-notice-region" role="status" aria-live="polite">
      {notice && (
        <button
          key={notice.id}
          type="button"
          className="board-notice"
          onClick={() => useEditor.getState().dismissNotice(notice.id)}
        >
          {notice.text}
        </button>
      )}
    </div>
  );
}
